import { Injectable } from '@angular/core';
import { CommunicationConfigService, ConfigService } from '@argalis-apps/angular-global';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import * as TEST from './data-test';
@Injectable({
  providedIn: 'root'
})
export class ApprenantService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  getApprenantBySession(idSession: number): Observable<any[]> {
    if (this.configService.getOptions().useTestData !== true) {
      return this.http.get<any[]>(
        `${this.communicationConfigService.getApiUri()}/session-apprenant-extranet/${idSession}`
      );
    }
    return null;
  }

  updateApprenantInfo(idApprenant: number, apprenantInfo): Observable<any> {
    if (this.configService.getOptions().useTestData === true) {
      return of['ok'];
    } else {
      return this.http.put<any>(
        `${this.communicationConfigService.getApiUri()}/session-apprenant-extranet/${idApprenant}`,
        apprenantInfo
      );
    }
  }
}
